import {Component, Input, OnInit} from '@angular/core';
import {TilesService} from "../../core";

@Component({
    selector: 'circle-progress',
    templateUrl: './circle-progress.component.html',
    styleUrls: ['./circle-progress.component.scss']
})
export class CircleProgressComponent implements OnInit {
    @Input() angleEnd: number;
    @Input() showPath: boolean;
    @Input() value: number;
    circlePath: string;

    constructor(
        private tiles: TilesService
    ) {
    }

    ngOnInit() {
        const angleEnd = this.angleEnd ? this.angleEnd : 0;
        this.circlePath = this.tiles.calculateCirclePoints(25, 25, 24, 0, angleEnd, 6).toString();
    }
}
